/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Contact { 
    id?: number;
    ownerOrganization?: string;
    ownerLogin?: string;
    global?: boolean;
    fullNumber?: string;
    shortNumber?: string;
    firstName?: string;
    lastName?: string;
    sex?: string;
    email?: string;
    title?: string;
    company?: string;
    department?: string;
    room?: string;
    jobTitle?: string;
    address?: string;
    zip?: string;
    city?: string;
    fax?: string;
    office?: string;
    qualifications?: string;
    fixedLine?: string;
    description?: string;
    hidden?: boolean;
    imageId?: number;
}
